import {useGetUserClientsTreeQuery} from '../../../../redux/userClientsApi';
import {useMemo} from 'react';
import {UserClient} from '../../../../types/TypesUser';
import {monthNow} from '../../../../assets/utils/dateUtils';
import {useSelector} from 'react-redux';
import {RootState} from '../../../../redux/store';

export const useClientsByLevel = () => {
	const month = monthNow();
	const {data} = useGetUserClientsTreeQuery(month);
	const children = data?.children ?? [];
	const user = useSelector((state: RootState) => state.userData.userView);
	const treeMap = useMemo(() => {
		const grouped: Record<string | number, UserClient[]> = {};
		for (const client of children) {
			const key = client.parent_id ?? 'root'; // заменяем null на строку
			if (!grouped[key]) grouped[key] = [];
			grouped[key].push(client);
		}
		return grouped;
	}, [children]);
	const me = children.find((c) => c.level === 0);
	return {
		me: {...me, photo: user?.photo ?? ''},
		all: children,
		treeMap,
	};
};
